module.exports = __webpack_public_path__ + "img/fb3a1f25-82b6-40a4-a58d-d91884fb0c04.99833de3.png";